angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-invite-factory',
        function ($api, $factory) {
            $api.factory.invite = $factory;
        },
    ])
    .factory('graph-invite-factory', [
        'graph-api-client',
        function (client) {
            function invites(entry, id) {
                if (entry === 'user') entry = undefined;

                this.query = function (options) {
                    return client.get([entry, id, 'invites'], options);
                };

                this.read = function (invite_id, options) {
                    return client.get(['invite', invite_id], options);
                };

                this.create = function (entry_id, data, options) {
                    return client.post([entry, id, 'invite', entry_id], data, options);
                };

                this.accept = function (invite_id, options) {
                    return client.post(['invite', invite_id], undefined, options);
                };

                this.reject = function (invite_id, options) {
                    return client.delete(['invite', invite_id], options);
                };

                this.massInvite = function (place, placeId, data, options) {
                    return client.post([entry, id, 'mass.invite', 'using.' + place + '.' + placeId], data, options);
                };

                this.viaEmail = function (data, options) {
                    return client.post([entry, id, 'invite.via.email'], data, options);
                };

                this.inviteToRegister = function (data, options) {
                    return client.post(['invite-to-register'], data, options);
                };
            }

            /**
             *  @type {String}
             */
            return {
                entry: function (entry, id) {
                    return new invites(entry, id);
                },
            };
        },
    ]);
